// De facetstand van InstantSearch terug naar filtercriteria: het omgekeerde van
// toIndexUiState in chat/filters.ts. Een verkenning bewaart zijn filter in die
// vorm (Workspace.criteria), zodat de chat en de server hem kunnen lezen.
// Bewust zonder config: deze logica draait in vitest (zie learnings).

export type Criteria = Record<string, string | string[] | { min?: number; max?: number }>;

interface IndexUiState {
  refinementList?: Record<string, string[]>;
  range?: Record<string, string>;
  hierarchicalMenu?: Record<string, string[]>;
}

const bound = (text: string | undefined) => {
  if (text === undefined || text === "") return undefined;
  const n = Number(text);
  return Number.isFinite(n) ? n : undefined;
};

export function fromIndexUiState(uiState: IndexUiState): Criteria {
  const criteria: Criteria = {};

  const [zone1, zone2] = uiState.hierarchicalMenu?.zone_1 ?? [];
  if (zone1) criteria.zone_1 = zone1;
  if (zone2) criteria.zone_2 = zone2;

  for (const [key, values] of Object.entries(uiState.refinementList ?? {})) {
    if (values?.length) criteria[key] = values;
  }

  for (const [key, value] of Object.entries(uiState.range ?? {})) {
    const [low, high] = (value ?? "").split(":");
    const range: { min?: number; max?: number } = {};
    const min = bound(low);
    const max = bound(high);
    if (min !== undefined) range.min = min;
    if (max !== undefined) range.max = max;
    if (Object.keys(range).length) criteria[key] = range;
  }

  return criteria;
}
